var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"report-sub-box"},[_c('div',{staticClass:"card p-2"},[_c('div',{staticClass:"card-body"},[_c('h5',[_vm._v(_vm._s(_vm.$t("dailyReport.noReport")))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }